import { ReactElement } from 'react';
import { Helmet } from 'react-helmet';
import { BRAND } from 'shared/Constants';

const HeadTag = (props: any): ReactElement => {
    const { title } = props;
    // UI Elements
    return (
        <Helmet>
            <title>
                {BRAND.MARKET_SITE} | {title}
            </title>
        </Helmet>
    );
};

export default HeadTag;
